import { render, staticRenderFns } from "./MailerSettings.vue?vue&type=template&id=17cbfa87&scoped=true&"
import script from "./MailerSettings.vue?vue&type=script&lang=js&"
export * from "./MailerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cbfa87",
  null
  
)

export default component.exports